import { Autosave } from '../autosave/autosave';
import { InventoryState } from './inventory.model';

export interface InventoryRepository {
  load(): InventoryState;
  save(state: InventoryState): void;
}

export class AutosaveInventoryRepository implements InventoryRepository {
  constructor(private readonly autosave: Autosave) {}

  load(): InventoryState {
    const stored = this.autosave.autosaveValue;
    return { items: stored?.items ?? {} };
  }

  save(state: InventoryState): void {
    this.autosave.save({ items: state.items });
  }
}
